import React from 'react';
import { ReactSVG } from 'react-svg';

import {
  CtaButton,
  CtaButtonWrapper,
  Title,
  TitleWrapper,
  UspItem,
  UspItemIconWrapper,
  UspItemText,
  UspItemTitle,
  UspWrapper,
} from './Usp.styles';

const Usp = ({ uspData }) => {
  const { mainTitle, usps, linkTitle, ctaUrl } = uspData;

  return (
    <>
      {mainTitle && (
        <TitleWrapper>
          <Title>{mainTitle}</Title>
        </TitleWrapper>
      )}
      <UspWrapper uspCount={usps.length}>
        {usps.map(usp => {
          const { id, icon, title, text } = usp;

          return (
            <UspItem key={id}>
              <UspItemIconWrapper>
                <ReactSVG src={`/images/icons/${icon}.svg`} />
              </UspItemIconWrapper>
              <UspItemTitle>{title}</UspItemTitle>
              <UspItemText>{text}</UspItemText>
            </UspItem>
          );
        })}
      </UspWrapper>
      {linkTitle && ctaUrl && (
        <CtaButtonWrapper>
          <CtaButton href={ctaUrl.url} type={ctaUrl.type} color="petrol" size="extraLarge">
            {linkTitle}
          </CtaButton>
        </CtaButtonWrapper>
      )}
    </>
  );
};

export default Usp;
